// src/app/store.ts
import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../features/auth/authSlice";
import ordersReducer from "../features/orderStatusHistories/ordersStatusHistoriesSlice"; // Import the new reducer
import pickupReducer from "../features/pickup/pickupSlice";
import linehaulReducer from "../features/linehaul/linehaulSlice";
import returnToShipperReducer from "../features/returnToShipper/returnToShipperSlice";
import staffReducer from "../features/staff/staffSlice";
import warehouseReducer from "../features/warehouse/warehouseSlice";
import driverReducer from "../features/driver/driverSlice";
import outSourceReducer from "../features/outSource/outSourceSlice";
import clientReducer from "../features/client/clientSlice";
import productReducer from "../features/product/productSlice";
import promoReducer from "../features/promo/promoSlice";
import fleetReducer from "../features/fleet/fleetSlice";
import changeRequestReducer from "../features/changeRequest/changeRequestSlice";
import odometerReducer from "../features/odometer/odometerSlice";
import fuelReducer from "../features/fuel/fuelSlice";
import driverMapReducer from "../features/driverMap/driverMapSlice";
import darkStoreReducer from "../features/darkStores/darkStoresSlice";
import productManifestReducer from "../features/productManifest/productManifestSlice";
import unifiedManifestReducer from "../features/unifiedManifest/unifiedManifestSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    orders: ordersReducer,
    pickup: pickupReducer,
    linehaul: linehaulReducer,
    returnToShipper: returnToShipperReducer,
    staff: staffReducer,
    warehouse: warehouseReducer,
    driver: driverReducer,
    outSource: outSourceReducer,
    client: clientReducer,
    product: productReducer,
    promo: promoReducer,
    fleet: fleetReducer,
    changeRequest: changeRequestReducer,
    odometer: odometerReducer,
    productManifest: productManifestReducer,
    unifiedManifest: unifiedManifestReducer,
    fuel: fuelReducer,
    driverMap: driverMapReducer,
    darkStores: darkStoreReducer
  },
});

// Update the types to include the new state slice
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
